<template>
  <div class="option-change-container">
    <a-row :gutter="8" v-if="!isEdit">
      <div class="option-change-box options-row" v-for="(val, index) in value" :key="index">
        <a-col :span="9">
          <a-tooltip placement="topLeft" style="padding-right:2px">
            <template slot="title">
              请填写名称
            </template>
            <Input v-model="val.label" placeholder="名称" />
          </a-tooltip>
        </a-col>
        <!-- <a-col :span="3">
          <a-tooltip placement="topLeft" style="padding-right:2px">
            <template slot="title">
              选项值
            </template>
            <Input v-model="val.value" placeholder="值" />
          </a-tooltip>
        </a-col>
        <a-col :span="3">
          <a-tooltip placement="topLeft" style="padding-right:2px">
            <template slot="title">
              映射值
            </template>
            <Input v-model="val.mappingValue" placeholder="映射" />
          </a-tooltip>
        </a-col>
        <a-col :span="3">
          <a-tooltip placement="topLeft" style="padding-right:2px">
            <template slot="title">
              排序
            </template>
            <Input v-model="val.sortNum" placeholder="排序" />
          </a-tooltip>
        </a-col> -->
        <a-col :span="4">
          <a-tooltip placement="topLeft" style="padding-right:2px">
            <template slot="title">
              上传选项图片
            </template>
            <j-image-upload class="avatar-uploader" :customWidth="32" text="上传" v-model="val.img" 
              :bizPath="`knowledge/form/${selectForm.id}/answser`"> </j-image-upload>
          </a-tooltip>
        </a-col>
        <!-- <a-col :span="2">
          <div @click="handleDelete(index)" class="option-delete-box">
            <a-icon type="delete" />
          </div>
        </a-col> -->
      </div>
      <a-col :span="24"><a @click="handleAdd">添加</a></a-col>
    </a-row>
    <!-- 批量新增选项 -->
    <a-row :gutter="8" v-if="isEdit && isBatch">
      <a-col :span="24">
        <div style="margin-bottom: 8px;">请输入选项，每行一个选项。格式：选项值-选项名称 或 选项值=选项名称，例如：0-否 或 1=是</div>
      </a-col>
      <a-col :span="24">
        <a-textarea v-model="batchInput" placeholder="请输入选项，每行一个选项。格式：选项编码-选项名称 或 选项编码=选项名称，例如：0-否 或 1=是" :rows="6"
          style="margin-bottom: 8px;" />
      </a-col>
    </a-row>
    <!-- 编辑选项 -->
    <a-row :gutter="8" v-if="isEdit && !isBatch" class="options-edit">
      <div class="options-editor">
        <draggable v-model="editOptions" :animation="150" @end="onDragEnd" handle=".drag-handle"
          class="draggable-container">
          <div v-for="(option, index) in editOptions" :key="index" class="option-item">
            <!-- 拖拽手柄 - 默认隐藏，hover时显示 -->
            <a-icon type="menu" class="drag-handle" />

            <Input v-model="option.value" placeholder="值" style="width: 66px;margin-right: 10px;" />

            <a-input v-model="option.label" class="option-input" placeholder="名称" />

            <Input v-model="option.mappingValue" placeholder="映射值" style="width: 66px;margin-right: 10px;" />

            <a-input v-model="option.description" class="option-input" placeholder="描述" />

            <a-radio :checked="option.defaultValue" @click="(e) => handleDefaultChange(e, index)" class="default-radio">
              默认选中
            </a-radio>

            <!-- 删除按钮 - 默认隐藏，hover时显示 -->
            <a-icon type="delete" class="delete-icon" @click="handleOptionDelete(index)"
              v-if="editOptions.length > 1" />
          </div>
        </draggable>
      </div>
      <a-button type="dashed" icon="plus" class="add-option-btn" @click="handleAddOption">
        添加选项
      </a-button>
    </a-row>
  </div>
</template>
<script>

import { pluginManager } from "../utils/index";
import JImageUpload from '@comp/jeecg/JImageUpload'
import draggable from "vuedraggable";
const Input = pluginManager.getComponent("input").component;
const InputNumber = pluginManager.getComponent("number").component;
export default {
  name: "CsimChangeOption",
  components: {
    Input,
    InputNumber,
    JImageUpload,
    draggable
  },
  data() {
    return {
      batchInput: "",
      editOptions: [],
    }
  },
  props: {
    selectForm: {
      type: Object,
      required: false
    },
    value: {
      type: Array,
      required: true
    },
    isBatch: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ""
    }
  },
  watch: {
    // 监听isBatch变化，当切换到批量模式时自动加载已有数据
    isEdit: {
      handler(val) {
        if (val) {
          if (this.$props.isBatch) {
            this.handleLoadExisting()
          } else {
            this.handleLoadOptions()
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    handleAdd() {
      // 添加
      const addData = [
        ...this.value,
        {
          value: `${this.value.length + 1}`,
          label: "选项" + (this.value.length + 1),
          mappingValue: null,
          description: null,
          sortNum: null,
          img: '',
          defaultValue: false,
          list: this.type === "tab" ? [] : undefined
        }
      ];
      this.$emit("input", addData);

      this.$emit('refreshOptions');
    },
    handleAddCol() {
      // 添加栅格Col
      const addData = [
        ...this.value,
        {
          span: 12,
          list: []
        }
      ];
      this.$emit("input", addData);

      this.$emit('refreshOptions');
    },
    handleAddRules() {
      const addData = [
        ...this.value,
        {
          pattern: "",
          message: ""
        }
      ];
      this.$emit("input", addData);

      this.$emit('refreshOptions');
    },
    handleDelete(deleteIndex) {
      // 删除
      this.$emit(
        "input",
        this.value.filter((val, index) => index !== deleteIndex)
      );

      this.$emit('refreshOptions');
    },
    // 批量添加选项
    handleBatchAdd() {
      if (!this.batchInput.trim()) {
        this.$message.warning('请输入选项内容');
        return false
      }

      const lines = this.batchInput.split('\n').filter(line => line.trim());
      const newOptions = [];

      lines.forEach((line, index) => {
        const trimmedLine = line.trim();
        if (!trimmedLine) return;

        let value = '';
        let label = '';

        // 解析连接符：支持 = 和 - 作为分隔符
        if (trimmedLine.includes('=')) {
          const parts = trimmedLine.split('=');
          value = parts[0].trim();
          label = parts.slice(1).join('=').trim(); // 处理可能包含多个=的情况
        } else if (trimmedLine.includes('-')) {
          const parts = trimmedLine.split('-');
          value = parts[0].trim();
          label = parts.slice(1).join('-').trim(); // 处理可能包含多个-的情况
        } else {
          // 如果没有连接符，则使用行号作为值，整行作为标签
          value = `${this.value.length + newOptions.length + 1}`;
          label = trimmedLine;
        }

        // 如果value为空，使用行号
        if (!value) {
          value = `${this.value.length + newOptions.length + 1}`;
        }

        // 如果label为空，使用value
        if (!label) {
          label = value;
        }
        const findItem = this.value.find((item) => item.value == value)
        if (findItem) {
          newOptions.push({
            value: value,
            label: label,
            mappingValue: findItem.mappingValue,
            description: findItem.description,
            sortNum: findItem.sortNum,
            img: findItem.img,
            list: findItem.list,
            defaultValue: findItem.defaultValue || false,
          })
        } else {
          newOptions.push({
            value: value,
            label: label,
            mappingValue: null,
            description: null,
            sortNum: this.value.length + 1,
            img: '',
            list: this.type === "tab" ? [] : undefined
          })
        }
      })

      if (newOptions.length === 0) {
        this.$message.warning('没有有效的选项内容');
        return false
      }
      const addData = newOptions
      this.$emit("input", addData)
      this.$emit('refreshOptions', true)
    },
    // 加载已有数据到批量输入框
    handleLoadExisting() {
      if (!this.value || this.value.length === 0) {
        this.$message.info('暂无已有数据');
        return;
      }
      const formattedLines = this.value.map(item => {
        // 使用"-"作为连接符，格式为：选项值-选项名称
        return `${item.value || ''}-${item.label || ''}`;
      });
      this.batchInput = formattedLines.join('\n');
    },
    // 拖拽结束回调
    onDragEnd(e) {
    },
    // 保存编辑的选项
    handleSaveOptions() {
      if (!this.editOptions || this.editOptions.length === 0) {
        this.$message.info('暂无编辑数据');
        return;
      }

      const value = JSON.parse(JSON.stringify(this.editOptions))
      this.$emit("input", value)
      this.$emit('refreshOptions', true)
    },
    handleLoadOptions() {
      if (!this.value || this.value.length === 0) {
        this.$message.info('暂无已有数据');
        return;
      }
      const value = JSON.parse(JSON.stringify(this.value))

      this.editOptions = value.map(item => ({
        ...item,
        defaultValue: item.defaultValue || false
      }))
    },
    handleDefaultChange(e, index) {
      if (this.type === 'radio') {
        // 单选模式：只能有一个选中
        this.editOptions = this.editOptions.map((item, i) => ({
          ...item,
          defaultValue: index === i ? !this.editOptions[index].defaultValue : false
        }))
      } else {
        // 多选模式：可以有多个选中
        this.editOptions[index].defaultValue = !this.editOptions[index].defaultValue
      }
    },

    handleAddOption() {
      const newOption = {
        value: `${this.editOptions.length + 1}`, // 自动生成value
        label: `选项${this.editOptions.length + 1}`, // 自动生成label
        defaultValue: false,
        mappingValue: null,
        description: null,
        sortNum: this.editOptions.length + 1,
        img: '',
        list: this.type === 'tab' ? [] : undefined
      }
      this.editOptions.push(newOption)
    },

    handleOptionDelete(index) {
      const isDefault = this.editOptions[index].defaultValue
      this.editOptions.splice(index, 1)

      if (isDefault && this.editOptions.length > 0) {
        this.editOptions[0].defaultValue = true
      }
    }
  }
};
</script>

<style lang="less" scoped>
.avatar-uploader {
  /deep/ .ant-upload-picture-card-wrapper {
    display: flex;
  }

  /deep/ .ant-upload {
    width: 40px !important;
    height: 40px !important;

    /deep/ .avatar-view {
      width: 40px !important;
      height: 40px !important;
    }
  }
}

.option-change-container .options-row {
  height: 70px;
  display: flex;
  align-items: center;
  flex-direction: row;
}

.options-edit {
  width: 100%;
  // height: 100%;
}

.options-editor {
  width: 100%;
  max-height: 30vh;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  // max-height: 100%;
  overflow-y: auto;
}

.draggable-container {
  margin-bottom: 16px;
}

.option-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
}

// 拖拽手柄样式
.drag-handle {
  color: #ccc;
  cursor: move;
  margin-right: 16px;
  font-size: 16px;
  transition: color 0.2s;

  &:hover {
    color: #888;
  }
}

.option-input {
  flex: 1;
  margin-right: 16px;
}

.default-radio {
  margin-right: 16px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;

  /deep/ .ant-radio-checked .ant-radio-inner {
    border-color: #1890ff;
    background-color: #1890ff;
  }

  /deep/ .ant-radio-inner:after {
    background-color: #fff;
  }
}

.delete-icon {
  color: #f5222d;
  cursor: pointer;
  font-size: 16px;
  transition: color 0.3s;

  &:hover {
    color: #cf1322;
  }
}

.add-option-btn {
  margin-top: 16px;
  width: 100%;
}

// 拖拽时的样式反馈
/deep/ .ghost {
  opacity: 0.5;
  background-color: #e6f7ff;
}

/deep/ .dragging {
  background-color: #f0f7ff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.option-delete-box {
  margin-left: -4px;
}
.avatar-uploader {
  :deep(.ant-upload) {
    >.ant-upload {
      line-height: 1.3;
      padding: 5px;
    }

    .ant-upload-text {
      font-size: 10px;
    }
  }
}
</style>
